import React from 'react';
import { Provider } from 'react-redux';
import MadeForYouWidget from './MadeForYouWidget';
import store from '~scenes/madeforyou/app/store/mfyStore';
import '~scenes/madeforyou/madeforyou.scss';
import '~shared/components/react/SportsWidget/styles/sports-widget.scss';

const MadeForYouWidgetContainer = () => (
    <Provider store={store}>
        <MadeForYouWidget />
    </Provider>
);

export default MadeForYouWidgetContainer;
